import { getBorderToken, getIconToken, getTextToken } from "../fundations/palette/colorTokens";
export const Menu = {
    MuiMenuItem: {
        defaultProps: {
            disableRipple: true
        },
        variants: [
            {
                props: {
                    color: "error"
                },
                style: ({ theme })=>({
                        "& .MuiTypography-root": {
                            color: getTextToken("textError", theme)
                        },
                        "& .MuiListItemIcon-root": {
                            color: getIconToken("iconDestructive", theme)
                        }
                    })
            }
        ],
        styleOverrides: {
            divider: ({ theme })=>({
                    borderBottom: `1px solid ${getBorderToken("border200", theme)}`
                }),
            root: ({ theme })=>({
                    padding: theme.spacing(1.25, 2)
                })
        }
    }
};

//# sourceMappingURL=Menu.js.map